import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 14,
	viewBox: "0 0 16 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.875 12.625L1.25 7M1.25 7L6.875 1.375M1.25 7H14.75",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgArrowLeft);
export default ForwardRef;
